import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AtaraxiaGridNavigationModule } from '@epicuro-next/ataraxia/grid-navigation';
import { AtaraxiaHorizontalScrollArrowsModule } from '@epicuro-next/ataraxia/horizontal-scroll-arrows';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';

import { AdvancedMdoGridComponent } from './components/advanced-mdo-grid/advanced-mdo-grid.component';

@NgModule({
  imports: [
    CommonModule,
    AtaraxiaHorizontalScrollArrowsModule,
    IconsModule,
    TooltipDirective,
    AtaraxiaGridNavigationModule,
    DragDropModule,
  ],
  declarations: [AdvancedMdoGridComponent],
  exports: [AdvancedMdoGridComponent],
})
export class FeaturesAdvancedMdoGridModule {}
